import {Base64} from "js-base64";

const LOCAL_JWT_KEY = "jskdfls";
import CryptoJS from 'crypto-js';

export const isStrEmpty = (str) =>{
    if (str == null || str == 'undefined' || !str || !/[^\s]/.test(str)) {
        return true;
    } else {
        return false;
    }
}

export const isObjectEmpty = (obj) => {
    if (obj == null
        || obj == 'undefined'
        || JSON.stringify(obj) === '{}'){
        return true;
    }else{
        return false;
    }
}

export const setJwtToken = (jwtToken) => {
    sessionStorage.setItem(LOCAL_JWT_KEY,jwtToken)
}
export const getJwtToken = () => {
    return sessionStorage.getItem(LOCAL_JWT_KEY)
}
export const getTokenUser = () => {
    let userString = decodeURIComponent(
        Base64.decode(getJwtToken().split('.')[1])
    )
    return JSON.parse(userString).sub
}

export const getTokenUserId = () => {
    let userString = decodeURIComponent(
        window.atob(getJwtToken().split('.')[1])
    )
    return JSON.parse(userString).userid;
}

export const getTokenRoleCode = () => {
    let userString = decodeURIComponent(
        window.atob(getJwtToken().split('.')[1])
    )
    return JSON.parse(userString).userRoleCode;
}

//浮点数加法运算
export const FloatAdd = function(arg1,arg2){
    let r1,r2,m;
    try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
    try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
    m=Math.pow(10,Math.max(r1,r2));
    return (arg1*m+arg2*m)/m;
}

//浮点数减法运算
export const FloatSub = function(arg1,arg2){
    let r1,r2,m,n;
    try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
    try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
    m=Math.pow(10,Math.max(r1,r2));
    //动态控制精度长度
    n=(r1=r2)?r1:r2;
    return ((arg1*m-arg2*m)/m).toFixed(n);
}

//浮点数乘法运算
export const FloatMul = function(arg1,arg2)
{
    let m=0, s1=arg1.toString(), s2=arg2.toString();
    try{
        m+=s1.split(".")[1].length
    }catch(e){}
    try{
        m+=s2.split(".")[1].length
    }catch(e){}
    return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m);
}


//浮点数除法运算
export const FloatDiv = function(arg1,arg2){
    let t1=0,t2=0,r1,r2;
    try{t1=arg1.toString().split(".")[1].length}catch(e){}
    try{t2=arg2.toString().split(".")[1].length}catch(e){}
    r1=Number(arg1.toString().replace(".",""));
    r2=Number(arg2.toString().replace(".",""));
    return (r1/r2)*Math.pow(10,t2-t1);
}

export const validatePhone = function(value,callback) {
    const reg =/^[1][3-9][0-9]{9}$/;
    if(value==''||value==undefined||value==null){
        callback(false);
    }else {
        if ((!reg.test(value)) && value != '') {
            callback(false);
        } else {
            callback(true);
        }
    }
}

export const getProvinceCityCountry = (address) =>{
    let reg = /.+?(省|市|自治区|自治州|县|区)/g;
    return address.match(reg);
}

export const formate_param_date = (fmt, datestr)=>{
    var date = new Date(datestr);
    let ret;
    const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
    };
    return fmt;
}

function format_date(now) {
    let year = now.getFullYear(); //年
    let month = now.getMonth() + 1; //月
    let day = now.getDate(); //日
    let hh = now.getHours(); //时
    let mm = now.getMinutes(); //分
    let ss = now.getSeconds(); //秒

    let clock = year + "";
    if (month < 10) {
        clock += "0";
    }
    clock += month + "";

    if (day < 10) {
        clock += "0";
    }
    clock += day + "";

    if (hh < 10) {
        clock += "0";
    }
    clock += hh + "";

    if (mm < 10) {
        clock += '0'
    }
    clock += mm;

    if (ss < 10) {
        clock += '0'
    }
    clock += ss;

    return clock;
}

export const compareTime = (time) =>{
    let time_end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);
    let today_end = format_date(time_end)
    if (today_end == time){
        return 1;
    }else{
        return 0;
    }
}

export const getStrEndWithNumbers = (str, numbers) => {
    let l = str.length;
    return str.substring(l - numbers);
}

export const encryptPassword = (password) =>{
    let keyStr = "CXMGNcYwTrtsadQmV935ONNXMUycpG1g"; //判断是否存在ksy，不存在就用定义好的key
    let key = CryptoJS.enc.Utf8.parse(keyStr);
    let srcs = CryptoJS.enc.Utf8.parse(password);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
}

export const decryptPassword = (password) => {
    let keyStr = "CXMGNcYwTrtsadQmV935ONNXMUycpG1g"; //判断是否存在ksy，不存在就用定义好的key
    let key = CryptoJS.enc.Utf8.parse(keyStr);
    let decrypt = CryptoJS.AES.decrypt(password, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}
